var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        'ccos-tile',
        {
            'ccos-tile--internal': _vm.internal,
            'ccos-tile--selected': _vm.selected,
            'ccos-tile--warning': _vm.warning,
            'ccos-tile--paddingless-content': _vm.paddinglessContent,
            'ccos-tile--paddingless-footer': _vm.paddinglessFooter,
        } ],attrs:{"title":_vm.title}},[_c('div',{staticClass:"ccos-tile__content"},[(_vm.selected && !_vm.noSelectedIcon)?_c('Selected',{staticClass:"ccos-tile__selected"}):_vm._e(),_vm._t("default")],2),(_vm.$scopedSlots.footer)?_c('div',{staticClass:"ccos-tile__footer"},[_vm._t("footer")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }